import React from "react";
import bodyHelperTypes from "../utils/BodyHelperTypes";
import UnorderedList from "../layouts/bodyLayouts/helpers/UnorderedList";
import Links from "../components/Links";



const LittleEyeFAQ_Content = [

    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [
            <>
                <b>What is the 1915(i) RISE Initiative?</b><br/>
                RISE stands for <b>Recovery, Independence, Support, and Engagement.</b> It’s a Kentucky Medicaid program that helps adults with a <b>primary diagnosis of serious mental illness (SMI)</b> access services in the community instead of relying on hospitals or institutions.
            </>,
            <>
                <b>Who is 1915(i) RISE for?</b><br/>
                1915(i) RISE is for adults who:
                <ul>
                    <li>Are <b>18 or older.</b></li>
                    <li>Are enrolled in <b>Kentucky Medicaid.</b></li>
                    <li>Have a <b>diagnosis of SMI</b>, such as schizophrenia, bipolar disorder, or major depression.</li>
                    <li>May also have a substance use disorder.</li>
                    <li>Need help with housing, daily living, or staying connected.</li>
                </ul>
            </>,
            <>
                <b>What kinds of help can I get through 1915(i) RISE?</b><br/>
                You may receive services such as, but not limited to:
                <ul>
                    <li>Case management.</li>
                    <li>Help finding or keeping housing.</li>
                    <li>Support with daily living (like cooking or cleaning).</li>
                    <li>Help returning to school or work.</li>
                    <li>Medication support.</li>
                    <li>Transportation to services or appointments.</li>
                    <li>Short-term relief for your caregiver.</li>
                </ul>

              You and your case manager will decide together what’s right for you. 
            </>,
            <>
                <b>How do I apply for 1915(i) RISE?</b><br/>
                You can:
                <ul>
                    <li>Ask your provider or case manager about 1915(i) RISE.</li>
                    <li><b>Call:</b>502-564-9189</li>
                    <li><b>Email:</b><a href="mailto:1915iRISEInitiative@ky.gov ">1915iRISEInitiative@ky.gov </a></li>
                    <li><b>Visit:</b><a href="https://dbhdid.ky.gov/1915iriseinitiative">https://dbhdid.ky.gov/1915iriseinitiative</a></li>
                </ul>
            </>,
            <>
                <b>What is the screening and assessment like?</b><br/>
                A 1915(i) RISE provider will:
                <ul>
                    <li>Contact you within <b>three business days </b>of referral.</li>
                    <li>Complete a <b>pre-screening</b> with you to understand your needs.</li>
                    <li>Schedule a formal <b>Assessment</b>.</li>
                </ul>
            </>,
            <>
               If eligible, you will work with a case manager to create a <b>Person-Centered Service Plan (PCSP).</b>
            </>,
            <>
                <b>Do I have to get all 10 services?</b><br/>
                No. You’ll only get the services that you and your case manager agree are helpful to you. You can <b>add or stop services at any time </b>based on your goals.
            </>,
            <>
                <b>What if I already receive services?</b><br/>
                1915(i) RISE is designed to add value, not duplicate services. Your case manager will work with you to:
                <ul>
                    <li>Coordinate with other Medicaid programs.</li>
                    <li>Avoid duplicating services you already receive.</li>
                    <li>Keep the providers you already trust.</li>
                </ul>
            </>,
            <>
                <b>Where do I get services?</b><br/>
                1915(i) RISE services are delivered in the <b>community, your home,</b> or in <b>non-institutional settings</b> like supported housing, job sites, or education programs.
            </>,
            <>
                <b>Do I have to pay for 1915(i) RISE?</b><br/>
                No. 1915(i) RISE services are covered by Kentucky Medicaid. There is no cost to you if you’re eligible.
            </>,
            <>
                <b>Can I choose my providers?</b><br/>
                Yes. You have the right to:
                <ul>
                    <li>Choose from certified 1915(i) RISE providers.</li>
                    <li>Change providers if you want to.</li>
                    <li>Be involved in every decision about your care.</li>
                </ul>
            </>,
            <>
                <b>What if I disagree with a decision or want to file a complaint?</b><br/>
                You can:
                <ul>
                    <li>Talk to your case manager.</li>
                    <li>File a grievance with your provider.</li>
                    <li>Contact Medicaid Member Services.</li>
                    <li>Appeal decisions about eligibility or services.</li>
                </ul>
            </>
        ]
    },



];

export default LittleEyeFAQ_Content;